module.exports = __webpack_public_path__ + "d5ee88e1747f3c10a5092ec45bd09625.fbx";